import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteTradingPartner,
  listTradingPartners,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 取引先マスタ 削除 mutation hook。
 * onSuccess で listTradingPartners を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 * 旧実装では license 別 3 つの list query を invalidate していたが、
 * タブ再編で取引先タブは単一の listTradingPartners を使うように変更。
 */
export function useDeleteTradingPartner(): InvalidatingMutationResultFor<
  typeof deleteTradingPartner
> {
  return useInvalidatingMutation(deleteTradingPartner, [
    createConnectQueryKey({
      schema: listTradingPartners,
      cardinality: 'finite',
    }),
  ])
}
